// components/ProfilePage.jsx

import { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Avatar,
  Grid,
  Divider,
  Button,
} from "@mui/material";
import {
  createIdentityAPIEndpoint,
  EndPoints,
} from "../../services/AuthServices";
import { useNavigate } from "react-router-dom";
import { EditOutlined, PersonOutlineOutlined, QrCode2Outlined } from "@mui/icons-material";

const ProfilePage = () => {
  const [student, setStudent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [previewUrl, setPreviewUrl] = useState("");
  const navigate = useNavigate();

  const downloadQRCode = () => {
    createIdentityAPIEndpoint(EndPoints.getQRCode)
      .fetchWithOptions({ responseType: "blob" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);

        link.setAttribute(
          "download",
          `student_${student.fullName}_${student.centerName}_qrcode.pdf`,
        );
        document.body.appendChild(link);
        link.click();

        link.remove();
        document.body.revokeObjectURL(link.href);
      })
      .catch((error) => {
        console.error("Error downloading QR code:", error);
      });
  };
  const fetchAndDisplayImage = async (imageName) => {
    try {
      const response = await createIdentityAPIEndpoint(
        EndPoints.getStudentImage(imageName),
      ).fetchWithOptions({ responseType: "blob" });
      const imageUrl = URL.createObjectURL(response.data);
      setPreviewUrl(imageUrl);
    } catch (error) {
      console.error("Error fetching image:", error);
    }
  };

  useEffect(() => {
    createIdentityAPIEndpoint(EndPoints.details)
      .fetch()
      .then((res) => {
        setStudent(res.data);
        if (res.data.imageName) {
          fetchAndDisplayImage(res.data.imageName);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching lessons:", err);
        setLoading(false);
      });
  }, [loading]);

  return (
    <section className="profile-page section">
      {" "}
      <div className="profile-container">
        {" "}
        {loading ? (
          <div className="profile-state">
            {" "}
            <div className="profile-loader" /> <p>جاري تحميل بياناتك...</p>{" "}
          </div>
        ) : student === null ? (
          <div className="profile-state">
            {" "}
            <div className="profile-state-icon">📭</div>{" "}
            <h3>لا توجد بيانات حاليًا</h3> <p>حاول مرة أخرى بعد قليل.</p>{" "}
          </div>
        ) : (
          <>
            {" "}
            <div className="profile-heading">
              {" "}
              <span className="profile-badge">✦ حساب الطالب</span>{" "}
              <h1>
                {" "}
                أهلاً بيك يا <span>{student.fullName}</span>{" "}
              </h1>{" "}
              <p> من هنا تقدر تراجع بياناتك وتعدل حسابك بسهولة. </p>{" "}
            </div>{" "}
            <Card className="profile-card">
              {" "}
              <CardContent className="profile-card-content">
                {" "}
                <Grid container spacing={4} alignItems="center">
                  {" "}
                  {/* Student Identity */}{" "}
                  <Grid item xs={12} md={4}>
                    {" "}
                    <div className="profile-identity">
                      {" "}
                      <div className="profile-avatar-wrapper">
                        {" "}
                        <Avatar
                          src={previewUrl}
                          alt={student.fullName}
                          className="profile-avatar"
                        />{" "}
                        <span className="profile-online-dot" />{" "}
                      </div>{" "}
                      <h2>{student.fullName}</h2>{" "}
                      <span className="profile-role"> طالب في PureEng </span>{" "}
                      <span className="profile-username">
                        {" "}
                        @{student.userName}{" "}
                      </span>{" "}
                    </div>{" "}
                  </Grid>{" "}
                  {/* Student Information */}{" "}
                  <Grid item xs={12} md={8}>
                    {" "}
                    <div className="profile-info">
                      {" "}
                      <div className="profile-info-heading">
                        {" "}
                        <PersonOutlineOutlined/>
                        <h3>بياناتك الشخصية</h3>{" "}
                      </div>{" "}
                      <div className="profile-info-grid">
                        {" "}
                        <div className="profile-info-item">
                          {" "}
                          <span>اسم المستخدم</span>{" "}
                          <strong>{student.userName || "—"}</strong>{" "}
                        </div>{" "}
                        <div className="profile-info-item">
                          {" "}
                          <span>المرحلة الدراسية</span>{" "}
                          <strong>{student.educationStage || "—"}</strong>{" "}
                        </div>{" "}
                        <div className="profile-info-item">
                          {" "}
                          <span>المركز / المجموعة</span>{" "}
                          <strong>{student.centerName || "—"}</strong>{" "}
                        </div>{" "}
                        <div className="profile-info-item">
                          {" "}
                          <span>رقم الهاتف</span>{" "}
                          <strong>{student.phoneNumber || "—"}</strong>{" "}
                        </div>{" "}
                        <div className="profile-info-item">
                          {" "}
                          <span>رقم ولي الأمر</span>{" "}
                          <strong>{student.parentNumber || "—"}</strong>{" "}
                        </div>{" "}
                      </div>{" "}
                    </div>{" "}
                  </Grid>{" "}
                </Grid>{" "}
                <Divider className="profile-divider" />{" "}
                <div className="profile-actions">
                  {" "}
                  <Button
                    variant="contained"
                    className="profile-primary-btn"
                    startIcon={<EditOutlined />}
                    onClick={() => navigate("/my-profile/edit")}
                  >
                    {" "}
                    تعديل بياناتي{" "}
                  </Button>{" "}
                  <Button
                    variant="outlined"
                    className="profile-secondary-btn"
                    startIcon={<QrCode2Outlined />}
                    onClick={downloadQRCode}
                  >
                    {" "}
                    تحميل QR Code{" "}
                  </Button>{" "}
                </div>{" "}
              </CardContent>{" "}
            </Card>{" "}
          </>
        )}{" "}
      </div>{" "}
    </section>
  );
};

export default ProfilePage;
